import { Box, Card, CardContent, CardMedia, Chip, IconButton, Stack, Typography } from '@mui/material'
import SaveIcon from '@mui/icons-material/Save'
import DeleteIcon from '@mui/icons-material/Delete'
import AddIcon from '@mui/icons-material/Add'
import { useEffect, useRef, useState } from 'react'
import DesplegableRubros from '../../AdminProducts/ABMProducts/components/DesplegableRubros'
import { CardFotosProps } from './cardsFotos'

const CardFotosMobile = ({
  foto,
  codesActuales,
  rubros,
  rubrosData,
  cambios,
  loading,
  setImgSelected,
  setExpandImg,
  handleSave,
  handleDelete,
  handleAddRubro,
  handleRemoveRubro
}: CardFotosProps) => {
  const [rubrosAbiertos, setRubrosAbiertos] = useState<Record<number, boolean>>({})
  const desplegableRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    if (rubrosAbiertos[foto.idIaEntrenamientoFoto]) {
      setTimeout(() => {
        const input = desplegableRef.current?.querySelector('input')
        if (input) {
          input.focus()
        }
      }, 100)
    }
  }, [rubrosAbiertos, foto.idIaEntrenamientoFoto])

  return (
    <Card
      key={foto.idIaEntrenamientoFoto}
      sx={{
        display: 'flex',
        flexDirection: 'column',
        maxHeight: '100%',
        margin: '0 1rem 0 1rem'
      }}
    >
      {/* Arriba: Imagen */}
      <Box
        sx={{
          width: '100%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          position: 'relative',
          backgroundColor: '#f5f5f5'
        }}
      >
        <CardMedia
          component="img"
          image={foto.url}
          sx={{
            width: '100%',
            objectFit: 'contain',
            cursor: 'pointer',
            maxHeight: 400
          }}
          onClick={() => {
            setImgSelected(foto.url)
            setExpandImg(true)
          }}
        />
      </Box>

      {/* Abajo: Contenido */}
      <CardContent
        sx={{
          width: '100%',
          display: 'flex',
          flexDirection: 'column'
        }}
      >
        <Box
          sx={{
            mb: 2,
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'flex-start',
            flexWrap: 'wrap',
            width: '100%'
          }}
        >
          <Typography variant="body2" fontWeight="bold" color="text.secondary" gutterBottom sx={{ mr: 1, mt: 0.3 }}>
            Rubros
          </Typography>

          <Stack
            direction="row"
            spacing={0.5}
            flexWrap="wrap"
            useFlexGap
            alignItems="center"
            sx={{ flex: 1, minWidth: 0 }}
          >
            {rubrosData.map((rubro) => (
              <Chip
                key={rubro.codRubro}
                label={rubro.nombreCompleto}
                size="small"
                onDelete={() => handleRemoveRubro(foto.idIaEntrenamientoFoto, codesActuales, rubro.codRubro)}
                sx={{ mb: 0.5 }}
              />
            ))}

            <IconButton
              size="small"
              onClick={() =>
                setRubrosAbiertos((prev) => ({
                  ...prev,
                  [foto.idIaEntrenamientoFoto]: !prev[foto.idIaEntrenamientoFoto]
                }))
              }
              sx={{
                width: 32,
                height: 32,
                border: 1,
                borderColor: 'divider',
                borderStyle: 'dashed'
              }}
            >
              <AddIcon fontSize="small" />
            </IconButton>

            {rubrosAbiertos[foto.idIaEntrenamientoFoto] && (
              <Box
                sx={{
                  flex: 1,
                  width: '100%',
                  minWidth: 120,
                  maxWidth: '100%',
                  display: 'flex',
                  alignItems: 'center',
                  '> *': { flex: 1 }
                }}
              >
                <DesplegableRubros
                  rubros={rubros}
                  onChange={(r: any) => {
                    handleAddRubro(foto.idIaEntrenamientoFoto, codesActuales, r.codRubro)
                    setRubrosAbiertos((prev) => ({ ...prev, [foto.idIaEntrenamientoFoto]: false }))
                  }}
                />
              </Box>
            )}
          </Stack>
        </Box>

        <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
          <strong>ID de Foto:</strong> {foto.idIaEntrenamientoFoto}
        </Typography>

        <Typography
          variant="body2"
          color="text.secondary"
          sx={{
            wordBreak: 'break-all',
            whiteSpace: 'normal',
            lineHeight: 1.3,
            mb: 2
          }}
        >
          <strong>URL:</strong> {foto.url}
        </Typography>

        <Box sx={{ display: 'flex', gap: 2, justifyContent: 'flex-end', marginTop: 'auto' }}>
          <IconButton
            disabled={!cambios || loading}
            color="primary"
            onClick={() => handleSave(foto.idIaEntrenamientoFoto)}
            sx={{ border: 1 }}
          >
            <SaveIcon />
          </IconButton>
          <IconButton
            disabled={loading}
            color="error"
            onClick={() => handleDelete(foto.idIaEntrenamientoFoto)}
            sx={{ border: 1 }}
          >
            <DeleteIcon />
          </IconButton>
        </Box>
      </CardContent>
    </Card>
  )
}

export default CardFotosMobile
